import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard } from 'lucide-react';

export const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isDashboard        = pathname === '/';

  return (
    <div className="main-content-header">
      <span className="main-content-header__title">Business Chatbot</span>
      <div className="main-content-header__actions">
        <button
          onClick={() => navigate('/')}
          className={`header-icon-btn${isDashboard ? ' header-icon-btn--active' : ''}`}
          title="Dashboard"
          aria-label="Dashboard"
        >
          <LayoutDashboard size={18} />
        </button>
      </div>
    </div>
  );
};
